import {
  FETCH_LANDMARKS,
  FETCH_LANDMARKS_SUCCESS,
  FETCH_LANDMARKS_FAILED,
} from '../store/types';

const INITIAL_STATE = {
  landmarks: null, // null = not loaded yet, [] = loaded but empty
  loading: false,
  error: { flag: false, msg: null },
};

export const landmarksreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LANDMARKS:
      return Object.assign({}, state, { loading: true });
    case FETCH_LANDMARKS_SUCCESS:
      return Object.assign({}, state, {
        landmarks: action.payload,
        loading: false,
        error: { flag: false, msg: null },
      });
    case FETCH_LANDMARKS_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: { flag: true, msg: action.payload },
      });
    default:
      return state;
  }
};
